// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  personaId: __t.u64().name("persona_id"),
  axis: __t.string(),
  subAxis: __t.string().name("sub_axis"),
  sampleSize: __t.u32().name("sample_size"),
  cumulativeDelta: __t.f64().name("cumulative_delta"),
  confidence: __t.f64(),
  lastUpdatedAt: __t.i64().name("last_updated_at"),
});
